import { ContentAudience } from "../types/contentAudience";

export const CONTENT_AUDIENCE_HINTS: Record<ContentAudience, string> = {
    [ContentAudience.Residential]: "Buyers, sellers, and homeowners.",
    [ContentAudience.Commercial]: "Investors, tenants, and property owners.",
};

// A Lead Generation piece is generated end to end, so the voice always applies.
// A MyBrand piece only meets the voice when AI generation runs: text the user
// types and publishes without AI Enhance is posted exactly as written. The hint
// says so rather than letting the selector imply more than it does.
export const MYBRAND_AUDIENCE_SCOPE_NOTE =
    "Applies to AI-generated content. Text you write yourself is posted as-is.";

export function contentAudienceHint(
    audience: ContentAudience,
    isMyBrand: boolean
): string {
    const base = CONTENT_AUDIENCE_HINTS[audience];
    return isMyBrand ? `${base} ${MYBRAND_AUDIENCE_SCOPE_NOTE}` : base;
}

// Display-only relabelling of Lead Generation subtypes for the commercial
// voice. The subtype VALUE is what the api validates and what everything
// persists, so it is never touched here — only the words in the dropdown, so a
// commercial user is not asked to pick "Home Valuation Curiosity".
//
// Keyed by the api's LeadConversionSubtype VALUES, which this repo cannot
// import. A rename server-side makes the lookup miss and fall through to the
// raw subtype, and nothing here can detect that: the spec's subtype list is a
// hand-copy of the same values, so it goes stale in step. The spec only pins
// this map against that copy, catching a typo or a one-sided edit within this
// repo. Keeping them in sync with the api is a manual cross-repo check.
export const COMMERCIAL_SUBTYPE_LABELS: Record<string, string> = {
    "Home Valuation Curiosity": "Property Valuation Curiosity",
};

export function leadGenSubtypeLabel(
    subtype: string,
    audience: ContentAudience
): string {
    if (audience !== ContentAudience.Commercial) return subtype;
    return COMMERCIAL_SUBTYPE_LABELS[subtype] ?? subtype;
}
